export const GET_MESSAGES = "GET_MESSAGES";
export const RESET_MESSAGES = "RESET_MESSAGES";
export const SET_MESSAGES_REQUEST_STATUS = "SET_MESSAGES_REQUEST_STATUS";
